module.exports = __webpack_public_path__ + "img/pasta-e-broccoli.f304c218.png";